export const defaultErrorMessages = {
  required: '$LABEL is mandatory',
  email: '$LABEL should be a valid email address',
  number: '$LABEL must be a number',
  float: '$LABEL must be a number',
  decimal: '$LABEL must be a number',
  telephone: '$LABEL should be a valid telephone number',
  minLength: '$LABEL must be $CONDITION characters or more',
  maxLength: '$LABEL must be $CONDITION characters or less',
  min: '$LABEL must be $CONDITION or more',
  max: '$LABEL must be $CONDITION or less',
  reservedCharacters: '$LABEL should not contain reserved characters',
  pattern: '$LABEL must be in a valid format',
  isBeforeNow: '$LABEL must be in the past',
  isAfterNow: '$LABEL must be in the future',
  isYearsOld: '$LABEL must be at least $CONDITION years old',
  minYear: '$LABEL must have a year of $CONDITION or after',
} as const;

export const COUNTRIES = [
  'United Kingdom',
  'Afghanistan',
  'Aland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia And Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burma',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Channel Islands',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, The Dem Rep Of The',
  'Cook Islands',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Isl & Mcdonald Isl',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Isle Of Man',
  'Israel',
  'Italy',
  'Ivory Coast',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'North Korea (DPR)',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Other',
  'Pakistan',
  'Palau',
  'Palestinian Terr., Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Helena',
  'Saint Kitts And Nevis',
  'Saint Lucia',
  'Saint Pierre And Miquelon',
  'Samoa',
  'San Marino',
  'Sao Tome And Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'St. Vincent & The Grenadines',
  'Sth Georgia & Sth Sndwch Isl',
  'Sudan',
  'Suriname',
  'Svalbard And Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad And Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks And Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',

  'United States',
  'Unspecified',
  'Unspec Australasian Country',
  'Unspec Caribbean Country',
  'Unspec Cent. American Cntry',
  'Unspec Cent. Asian Cntry',
  'Unspec East African Country',
  'Unspec East Europe. Country',
  'Unspec Far Eastern Country',
  'Unspec Indian Ocean Island',
  'Unspec Melanesian Country',
  'Unspec Micronesian Country',
  'Unspec Middle Eastern Cntry',
  'Unspec Near Eastern Country',
  'Unspec North African Country',
  'Unspec North American Cntry',
  'Unspec North Atlantic Island',
  'Unspec North European Cntry',
  'Unspec Polynesian Country',
  'Unspec South African Country',
  'Unspec South American Cntry',
  'Unspec South Asian Country',
  'Unspec South Atlantic Island',
  'Unspec South European Cntry',
  'Unspec Southeast Asian Cntry',
  'Unspec Southern Ocean Isl',
  'Unspec West African Country',
  'Unspec West European Cntry',
  'Uruguay',
  'USA Minor Outlying Islands',
  'Uzbekistan',
  'Vanuatu',
  'Vatican City',
  'Venezuela',
  'Vietnam',
  'Virgin Islands (British)',
  'Virgin Islands (U.S.)',
  'Wallis And Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

export const MEDICALCONDITIONS = [
  'Abnormal heart rate or arrhythmias or heart surgery',
  'Amnesia',
  'Bi-polar disorder',
  'Brain haemorrhage or aneurysm',
  'Brain tumour',
  'Cardiomyopathy',
  'Deliberate self-harm or suicidal intent or suicide attempt',
  'Delusional disorder',
  'Dementia',
  'Diabetes - Type 1',
  'Diabetes - Type 2',
  'Epilepsy',
  'Heart failure',
  'Medically diagnosed depression',
  'Obsessive compulsive disorder (OCD)',
  'Pacemaker or implanted defibrillator',
  'Personality disorder (that has required professional input)',
  'Post-traumatic stress disorder (PTSD)',
  'Psychosis',
  'Schizophrenia',
  'Sleep apnoea',
  'Other condition causing fits, seizures, blackouts and faints (sudden loss of consciousness)',
  'None of the above',
];

export const COURTOUTCOMES = [
  'Not guilty/Not proven',
  'Absolute discharge',
  'Conditional discharge',
  'Banned from driving',
  'Mistrial',
  'Fixed Penalty/Fine',
  'Referral Order',
  'Custodial prison sentence',
  'Suspended prison sentence',
  'Community sentence or youth rehabilitation order',
  'Caution',
  'NFA',
];

export const ARRESTOUTCOMES = [
  'Released without charge/NFA',
  'Cautioned',
  'Charged with offence',
  'Bailed under investigation',
  'Fixed penalty notice',
  'Other',
];

export const MILITARYCOURTOUTCOMES = [
  'Not guilty',
  'Dismissal from service',
  'Reduced in rank',
  'Reprimand',
  'Severe reprimand',
  'Detention',
  'Admonished',
];

export const CLEARANCELEVELS = ['CTC', 'SC', 'DV', 'EDV', 'Other', "Don't know"];

export const DEPARTMENTS = [
  'Arts Council England (ACE)',
  'Attorney Generals Office (AGO)',
  'British Business Bank (BBB)',
  'Cabinet Office (CO)',
  'Cabinet Office Core (CO CORE)',
  'Customer Service Group (CSG)',
  'Department for Business & Trade (DBT)',
  'Department for Culture, Media & Sport (DCMS)',
  'Department for Education (DFE)',
  'Department for Energy Security & Net Zero (DESNZ)',
  'Department for Environment, Food & Rural Affairs (DEFRA)',
  'Department for Science, Innovation & Technology (DSIT)',
  'Department for Transport (DFT)',
  'Department for Work & Pensions (DWP)',
  'Department of Health & Social Care (DHSC)',
  'Food Standards Agency (FSA)',
  'Foreign, Commonwealth & Development Office (FCDO)',
  'Forestry Commission (FC)',
  'HM Revenue & Customs (HMRC)',
  'HM Treasury (HMT)',
  'Home Office (HO)',
  'Home Office Core (HO CORE)',
  'Medicines & Healthcare Products Regulatory Agency (MHRA)',
  'Ministry of Defence (MOD)',
  'Ministry of Housing, Communities & Local Government (MHCLG)',
  'Ministry of Justice (MOJ)',
  'Ministry of Justice Core (MOJ CORE)',
  'National Archives (NA)',
  'Northern Ireland Office (NIO)',
  'Office of Communications (OFCOM)',
  'Other',
  'Public Accounts Commission (PAC)',
  'Public Accounts Commission (PAC CORE)',
  'Rural Payments Agency (RPA)',
  'Scotland Office (SO)',
  'Supreme Court of the United Kingdom (SCUK)',
  'UK Export Finance (UKEF)',
  'UK Statistics Authority (STAT)',
];

export const CHILD_ORGS = [
  'Advisory Committee on Business Appointments (ACOBA)',
  'Advisory Committee on Releases to the Environment (ACRE)',
  'Advisory, Conciliation & Arbitration Service (ACAS)',
  'Agriculture & Horticulture Development Board (AHDB)',
  'Animal & Plant Health Agency (APHA)',
  'Arts Council England (ACE)',
  'Association of Commonwealth Universities (ACU)',
  'Attorney Generals Office Core (AGO CORE)',
  'Birmingham Organising Committee (BIRM)',
  'Board of Trustees of the Royal Botanic Gardens Kew (KEW)',
  'Bounce Back Loan Scheme (BBL)',
  'British Broadcasting Corporation (BBC)',
  'British Business Bank (BBB)',
  'British Film Institute (BFI)',
  'British Hallmarking Council (BHC)',
  'British Library (BLIB)',
  'British Museum (BMUS)',
  'Cabinet Office Core (CO CORE)',
  'Central Arbitration Committee (CAC)',
  'Centre for Environment, Fisheries & Aquaculture Science (CEFAS)',
  'Certification Officer (CERT)',
  'Charity Commission for England & Wales (CHAR)',
  'Churches Conservation Trust (CCT)',
  'Civil Nuclear Police Authority (CNPA)',
  'Civil Service Commission (CSC)',
  'Civil Service Pensions Scheme (CSPS)',
  'Committee on Climate Change (COCC)',
  'Committee on Fuel Poverty (COFP)',
  'Committee on Radioactive Waste Management (CRWM)',
  'Committee on Standards in Public Life (CSPL)',
  'Companies House (CH)',
  'Competition & Markets Authority (CMA)',
  'Competition Appeal Tribunal (CAT)',
  'Competition Service (COSV)',
  'Construction Industry Training Board (CITB)',
  'Consumer Council for Water (CCW)',
  'Crown Commercial Service (CCS)',
  'Crown Prosecution Service (CPS)',
  'Department for Business & Trade Core (DBT CORE)',
  'Department for Culture, Media & Sport Core (DCMS CORE)',
  'Department for Education Core (DFE CORE)',
  'Department for Energy Security & Net Zero Core (DESNZ CORE)',
  'Department for Environment, Food & Rural Affairs Core (DEFRA CORE)',
  'Education & Skills Funding Agency (ESFA)',
  'Electricity Settlements Company (ESC)',
  'Engineering Construction Industry Training Board (ECITB)',
  'English Heritage (ENGHER)',
  'Environment Agency (EA)',
  'Equality & Human Rights Commission (EHRC)',
  'Financial Reporting Council (FRC)',
  'Forestry Commission (FC)',
  'Gambling Commission (GC)',
  'Government Legal Department (GLD)',
  'Government Property Agency (GPA)',
  'Great British China Centre',
  'Great British Nuclear (GBN)',
  'Groceries Code Adjudicator (GCA)',
  'Historic England (HIST)',
  'HM Passport Office (HMPO)',
  'Horniman Museum & Public Park Trust (HORN)',
  'Horserace Betting Levy Board (HBLB)',
  'House of Lords Appointment Commission (HLAC)',
  'Imperial War Museum (IWM)',
  'Independent Commission for Aid Impact',
  'Infected Blood Compensation Authority  (IBCA)',
  'Insolvency Rules Committee (INSRC)',
  'Insolvency Service (INS)',
  'Institute for Apprenticeships & Technical Education (IFATE)',
  'Joint Nature Conservation Committee (JNCC)',
  'Livestock Information (LI)',
  'LocatEd Property Limited (LOCAT)',
  'Low Pay Commission (LPC)',
  'Marine Management Organisation (MMO)',
  'Marshall Aid Commission',
  'Mining Remediation Authority (MRA)',
  'Museum of the Home (MOH)',
  'National Archives (NA)',
  'National Citizen Service (NCS)',
  'National Gallery (NG)',
  'National Heritage Memorial Fund (NHMF)',
  'National Lottery Community Fund (NLCF)',
  'National Museums Liverpool (NML)',
  'National Portrait Gallery (NPG)',
  'Natural England (NE)',
  'Natural History Museum (NHM)',
  'NHS Business Services Authority (BSA)',
  'North Sea Transition Authority (NSTA)',
  'Nuclear Decommissioning Authority (NDA)',
  'Oak National Academy Limited (OAK)',
  'Office for Environmental Protection (OEP)',
  'Office for Standards in Education, Children’s Services & Skills (OFSTED)',
  'Office for Students (OFS)',
  'Office of Gas & Electricity Markets (OFGEM)',
  'Office of Qualifications & Examinations Regulation (OFQUAL)',
  "Office of the Children's Commissioner (OCC)",
  'Other',
  'Parliamentary & Health Service Ombudsman (PHSO)',
  'Plant Varieties & Seeds Tribunal (PVST)',
  'Post Office (PO)',
  'Public Sector Fraud Authority (PSFA)',
  'Pubs Code Adjudicator (PCA)',
  'Regulatory Policy Committee (RPC)',
  'Reviewing Committee on the Export of Works of Art & Objects of Cultural Interest (RCEWA)',
  'Royal Armouries Museum (RAM)',
  'Royal Museums Greenwich (RMG)',
  'Rural Payments Agency (RPA)',
  'Salix Finance (SF)',
  "School Teachers' Review Body (STRB)",
  'Science Advisory Council (SAC)',
  'Science Museum Group (SMG)',
  'Seafish (SEA)',
  'Security Vetting Appeals Panel (SVAP)',
  'Senior Salaries Review Body (SSRB)',
  'Serious Fraud Office (SFO)',
  "Sir John Soane's Museum (SJSM)",
  'Small Business Commission (SBC)',
  'Social Mobility Commission (SMC)',
  'Social Work England (SWE)',
  'Sport England (SE)',
  'Sports Grounds Safety Authority (SGSA)',
  'Standards & Testing Agency (STA)',
  'Start Up Loans Scheme (SUL)',
  'Student Loans Company (SLC)',
  'Tate (TATE)',
  'Teaching Regulation Agency (TRA)',
  'Theatres Trust (TTT)',
  'Trade Remedies Authority (TRAU)',
  'Treasure Valuation Committee (TVC)',
  'UK Anti-Doping (UKAD)',
  'UK Atomic Energy Authority (UKAEA)',
  'UK National Nuclear Laboratory (UKNNL)',
  'UK Sport (UKSP)',
  'UK Statistics Authority (STAT)',
  'UK Visa & Immigration (UKVI)',
  'Veterinary Medicines Directorate (VMD)',
  'Veterinary Products Committee (VPC)',
  'Victoria & Albert Museum (VA)',
  'VisitBritain (VB)',
  'Wallace Collection (WC)',
  'Water Services Regulation Authority (OFWAT)',
  'Westminster Foundation for Democracy',
  'Wilton Park',
];
